<template>
  <!-- v-drag-and-drop:options="dragOptions" -->
  <div
    id="surveys-builder-editor"
    :class="{ dragging: dragging }"
    class="d-md-block d-flex justify-content-center align-items-center d-sm-flex"
    style="height: 100vh;"
  >
  <div class="container-fluid p-0">
    <div class="row m-0">
      <div
        class="preview-col"
        :class="{
          'col-md-12': currentStep >= builderSteps.emailConfigStep,
          'col-md-8': currentStep < builderSteps.sendingOptionsStep,
        }"
      >
      <div class="card card-preview" :class="{ scrolling: isScrolling }">
          <div class="card-header" v-if="currentStep !== builderSteps.sendingOptionsStep">
            <div class="d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap">
            <!-- Title and Editing Section -->
            <div class="surveys-title w-100 w-md-auto mb-3 mb-md-0">
              <h4 class="header-case">
                <span class="step-badge">{{ currentStep }}</span>
                {{ stepTitle }}
              </h4>
              <div class="title" v-if="!titleEditable">
                <p>
                  <strong>{{ survey.title }}</strong>
                  <a href="#" @click.prevent="toggleSurveyTitleEditable(true)">
                    <img class="edit-icon ml-2" src="/assets/img/1.0/edit.png" alt="Edit" />
                  </a>
                </p>
              </div>
              <div class="title-edit d-flex" v-else>
                <input
                  class="bottom-input"
                  placeholder="Enter a title for your survey"
                  type="text"
                  v-model="survey.title"
                  ref="survey_title_input"
                  :class="{ 'border-danger': survey.title.length < 3 }"
                />
                <button class="btn btn-primary ml-2" @click="toggleSurveyTitleEditable(false)">
                  {{ __('SAVE') }}
                </button>
              </div>
            </div>

            <!-- Actions Section -->
            <div
              class="main-survey-actions w-100 w-md-auto d-flex justify-content-around justify-content-md-end pr-md-3 flex-wrap"
            >
                <a href="#" class="mb-2 mb-md-0" @click="cancelAll">{{ __('CANCEL') }}</a>
                <a href="#" class="mb-2 mb-md-0" :disabled="currentStep == 1" @click.prevent="previousStep">{{ __('BACK') }}</a>
                <a href="#" class="mb-2 mb-md-0" @click.prevent="nextStep" v-show="currentStep < 6">{{ __('NEXT') }}</a>
              </div>
            </div>
          </div>
          <div class="card-body text-center" ref="preview_body" v-if="currentStep === builderSteps.sendingOptionsStep">
            <div>
              <h3>Select Sending Options</h3>
            </div>
            <div class="custom-control custom-switch my-4">
              <input
                type="checkbox"
                v-model="ruleEnabled"
                @change="toggleRule"
                class="custom-control-input"
                id="customSwitches"
              />
              <label class="custom-control-label" for="customSwitches"
                >Do you want to enable automatic scheduling?</label
              >
            </div>
            <div v-if="ruleEnabled">
              <div>
                <p>Select when do you want your guests to receive the email invitation</p>
              </div>
              <div>
                <h4>{{ survey.title }}</h4>
              </div>
              <div class="mb-3">{{ survey.fields.length }} Questions</div>
              <div class="survey-rules-container">
                <div class="line">
                  <div class="item">Send survey</div>
                  <div class="item">
                    <input
                      type="number"
                      v-on:keydown.prevent.stop=""
                      v-model="survey.rules.sendingRule.afterDays"
                      min="0"
                      max="27"
                    />
                  </div>
                  <div class="item">days</div>
                  <div class="item">
                    <select v-model="survey.rules.sendingRule.type">
                      <option value="after_checkin">after check in</option>
                      <option value="after_checkout">after check out</option>
                      <option value="before_checkin">before check in</option>
                      <option value="before_checkout">before check out</option>
                    </select>
                  </div>
                </div>

                <div class="line">
                  <div class="item">At</div>
                  <div class="item">
                    <input
                      v-model="survey.rules.sendingRule.time"
                      v-on:keypress.prevent.stop="disableKeyPress"
                      step="1"
                      type="number"
                      min="1"
                      max="24"
                    />
                  </div>
                  <div class="item">UTC TIME</div>
                </div>
              </div>
            </div>
            <div class="custom-control custom-switch my-4">
              <input
                type="checkbox"
                v-model="expiryEnabled"
                @change="toggleExpiry"
                class="custom-control-input"
                id="customSwitchExpiry"
              />
              <label class="custom-control-label" for="customSwitchExpiry"
                >Do you wish to set a response deadline for the survey?</label
              >
            </div>
            <div v-if="expiryEnabled">
              <div>
                <p>Specify duration</p>
              </div>
              <div class="survey-rules-container">
                <div class="line">
                  <div class="item">Expiration</div>
                  <div class="item">
                    <input
                      type="number"
                      v-on:keydown.prevent.stop=""
                      v-model="survey.rules.expiryRule.afterDays"
                      min="0"
                      max="90"
                    />
                  </div>
                  <div class="item">days</div>
                </div>
              </div>
            </div>
            <div class="mt-3 mb-3">
              <button class="btn btn-primary btn-lg" @click.prevent="saveSurvey">
                {{ __('CONFIRM') }}
              </button>
            </div>
            <div>
              <button class="btn btn-default btn-lg" @click.prevent="previousStep">
                {{ __('BACK') }}
              </button>
            </div>
          </div>
          <div class="card-body" ref="preview_body" v-if="currentStep == builderSteps.surveyImagesStep">
            <div class="survey-images">
              <div class="survey-option mb-4">
                <strong class="option-title">{{ __('Do you want to add a custom logo to your survey?') }}</strong>
                <div class="btn-group mt-4 mb-4" role="group" aria-label="First group">
                  <button
                    type="button"
                    class="btn btn-tab-group"
                    v-on:click="setCustomBrandingLogoImage(false)"
                    v-bind:class="{
                      'btn-primary': !customBrandingLogoImage,
                    }"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    class="btn btn-tab-group"
                    v-on:click="setCustomBrandingLogoImage(true)"
                    v-bind:class="{
                      'btn-primary': customBrandingLogoImage,
                    }"
                  >
                    Yes
                  </button>
                </div>
              </div>
              <div v-if="customBrandingLogoImage" class="survey-logo-available-images">
                <div class="images-head">
                  <strong class="option-title">{{ __('Select the logo image for the survey') }}</strong>
                  <input type="hidden" v-model="survey.surveyImageLogoId" />
                </div>
                <div class="option-input">
                  <div class="row survey-edit-images">
                    <div
                      class="col-md-4"
                      v-for="image in availableSurveyImages"
                      v-if="image.type == 'logo'"
                      @click="setSurveyImage(image.type, image.id)"
                    >
                      <div class="survey-edit-image">
                        <img
                          :image-id="image.id"
                          class="img-fluid"
                          v-bind:class="{
                            active: survey.surveyImageLogoId == image.id,
                          }"
                          :src="getSurveyImageUrl(image)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="survey-option mb-4">
                <strong class="option-title">{{ __('Do you want to add a custom main image to your survey?') }}</strong>
                <div class="btn-group mt-4 mb-4" role="group" aria-label="First group">
                  <button
                    type="button"
                    class="btn btn-tab-group"
                    v-on:click="setCustomBrandingMainImage(false)"
                    v-bind:class="{
                      'btn-primary': !customBrandingMainImage,
                    }"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    class="btn btn-tab-group"
                    v-on:click="setCustomBrandingMainImage(true)"
                    v-bind:class="{
                      'btn-primary': customBrandingMainImage,
                    }"
                  >
                    Yes
                  </button>
                </div>
              </div>
              <div v-if="customBrandingMainImage" class="survey-main-available-images">
                <div class="images-head">
                  <strong class="option-title">{{ __('Select the main image for the survey') }}</strong>
                  <input type="hidden" v-model="survey.surveyImageMainId" />
                </div>
                <div class="option-input">
                  <div class="row survey-edit-images">
                    <div
                      class="col-md-4"
                      v-for="image in availableSurveyImages"
                      v-if="image.type == 'main'"
                      @click="setSurveyImage(image.type, image.id)"
                    >
                      <div class="survey-edit-image">
                        <img
                          :image-id="image.id"
                          class="img-fluid"
                          v-bind:class="{
                            active: survey.surveyImageMainId == image.id,
                          }"
                          :src="getSurveyImageUrl(image)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" ref="preview_body" v-if="currentStep !== builderSteps.sendingOptionsStep">
            <draggable
              class="dragArea list-group"
              group="fields"
              id="gf-survey"
              :list="[]"
              @change="addNew"
              :options="{ handle: '.is-draggable' }"
              v-show="isPreviewVisible"
              @start="dragStart"
              @end="updateAnswerOrder(field)"
            >
              <div
                class="field builder-mode py-3 mx-0"
                style="border: 0 !important"
                :options="{ disabled: false }"
                :class="{
                  'triggerable-field': field.triggeredBy && field.triggeredBy.length,
                  'is-draggable': field.mode == 'preview',
                  'edit-mode': field.mode == 'edit',
                  'create-mode': field.mode == 'create',
                  'temp-mode': field.mode == 'temporary_preview',
                }"
                v-for="(field, index) in survey.fields"
                :key="index"
              >
              <div v-if="field.notification" class="alert alert-warning">
                {{ field.notification }}
              </div>

              <!-- Responsive Options -->
              <div
                  class="field-options contextual-menu"
                  v-if="field.mode == 'preview'"
                  :class="{
                    expanded: activeOptions == index,
                  }"
                >
                  <a href="#" class="dots" @click.prevent="toggleOptions(index)">
                    <img src="/assets/img/1.0/three-dots.png" alt="Options" />
                  </a>
                  <ul class="options">
                    <li class="option">
                      <a href="#" @click.prevent="toggleFieldMode(index, 'edit')">Edit</a>
                    </li>
                    <li class="option" v-if="field.type == 'range'">
                      <a href="#" @click.prevent="toggleRangeMode"
                        >Change maximum scores to {{ survey.options.outOfFive ? '10' : '5' }}</a
                      >
                    </li>
                    <li class="option">
                      <a href="#" @click.prevent="removeField(index, true)">Delete</a>
                    </li>
                  </ul>
                </div>

              <!-- Edit Field Options -->
              <div class="edit-field-options" v-show="field.mode == 'edit' || field.mode == 'create'">
                <div class="edit-title">
                  <input type="text" v-model="field.title" placeholder="Type your question here.." />
                  <p class="error-message text-danger" v-for="error in getErrors(field, 'title')">
                    {{ error.message }}
                  </p>
                </div>
                <div class="edit-description">
                  <input type="text" v-model="field.description" placeholder="Enter a description (Optional)" />
                  <p class="error-message text-danger" v-for="error in getErrors(field, 'description')">
                    {{ error.message }}
                  </p>
                </div>
                <div class="edit-placeholder" v-if="hasPlaceholder(field.type)">
                  <input
                    type="text"
                    v-model="field.placeholder"
                    placeholder="Enter a hint to help guests type an answer"
                  />
                  <p class="error-message text-danger" v-for="error in getErrors(field, 'placeholder')">
                    {{ error.message }}
                  </p>
                </div>
                <div class="mb-3" v-show="field.type != 'explanation'">
                  <select v-model="field.topicId">
                    <option v-bind:value="topic.id" v-for="topic in topics">
                      {{ topic.name }}
                    </option>
                  </select>
                </div>
                <div class="form-check px-0" v-show="field.type != 'explanation'">
                  <label class="m-0"> Required field </label>
                  <input type="checkbox" v-model="field.required" class="required-checkbox align-middle" />
                </div>
                <div class="form-check px-0" v-show="field.type == 'range'">
                  <label class="m-0"> NPS question </label>
                  <input
                    type="checkbox"
                    v-on:click="checkSingleNps($event)"
                    v-model="field.isNps"
                    class="required-checkbox align-middle"
                  />
                </div>
                <div class="form-check px-0" v-if="field.type == 'range' && survey.options.outOfFive">
                  <label class="m-0"> Use alternative style for range </label>
                  <input type="checkbox" v-model="field.alternativeStyle" class="required-checkbox align-middle" />
                </div>
                <div class="form-check px-0" v-if="field.type == 'range'">
                  <label class="m-0"> Use condensed style for range </label>
                  <input type="checkbox" v-model="field.condensed" class="required-checkbox align-middle" />
                </div>
                <div class="field-add-answers-wrapper">
                  <div
                    class="field-add-answers"
                    v-if="hasAnswers(field.type) && (field.mode == 'edit' || field.mode == 'create')"
                  >
                    <draggable
                      :list="field.answerOptions"
                      :options="{ handle: '.drag-handle' }"
                      @end="updateAnswerOrder(field)"
                    >
                      <div class="new-answer" v-for="(answer, index) in field.answerOptions" :key="answer.id">
                        <p class="light-text">
                          {{ __('ANSWER') }} {{ index + 1 }}
                        </p>
                        <div class="input-wrapper px-0">
                          <a
                            class="info-circle large"
                            href="#"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="If enabled an alert will be sent to the emails you have setup, every time someone selects this answer"
                            :class="{ success: answer.alertEnabled }"
                            @click.prevent="toggleAlertEnabled(answer)"
                          >
                          <i class="fas fa-bell"></i>
                          </a>
                          <input
                            class="action-textbox w-75"
                            type="text"
                            placeholder="Enter an answer.."
                            v-model="answer.value"
                          />
                          <span class="drag-handle"><i class="fa fa-bars"></i></span>
                          <a
                            href="#"
                            class="action-remove text-danger"
                            @click.prevent="removeAnswerOption(field, index)"
                            v-if="field.answerOptions.length > 1"
                          >
                            <i class="fa fa-times"></i>
                          </a>
                        </div>
                      </div>
                    </draggable>
                    <div class="add-answer-actions">
                      <a href="#" class="blue-link" @click.prevent="addFieldAnswer(field)">
                        {{ __('ADD ANSWER') }} <i class="fa fa-plus circular"></i>
                      </a>
                    </div>
                  </div>
                  <p class="error-message text-danger" v-for="error in getErrors(field, 'answer_options')">
                    {{ error.message }}
                  </p>
                </div>
                <div
                  class="trigger-options-wrapper"
                  :class="{
                    'to-expanded': triggerOptionExpanded(field),
                  }"
                >
                  <a
                    href="#"
                    class="link-option"
                    :class="{
                      active: triggerOptionExpanded(field),
                    }"
                    @click.prevent="toggleTriggerOptions(field)"
                    ><i class="fas fa-fire"></i> Trigger Options</a
                  >
                  <div class="trigger-options" v-if="triggerOptionExpanded(field)">
                    <span>Show this field when</span>
                    <label for="select-trigger-field"><b>Field</b></label>
                    <select
                      id="select-trigger-field"
                      v-model="selectedTriggerField"
                      :disabled="field.hasTriggerEnabled || (field.triggeredBy && field.triggeredBy.length > 0)"
                    >
                      <option
                        v-for="oneField in survey.fields"
                        :value="oneField"
                        v-if="shouldShowTriggerField(oneField, field)"
                      >
                        {{ oneField.title }}
                      </option>
                    </select>
                    <div class="d-inline-flex align-middle align-items-center" v-if="selectedTriggerField">
                      <span> ({{ ucFirst(selectedTriggerField.type) }})&nbsp; </span>
                      <div class="d-flex align-items-center w-100" v-if="selectedTriggerField.type == 'range'">
                        <span class="text-nowrap">is lower than</span>
                        <input
                          class="form-control mx-2"
                          type="number"
                          min="1"
                          :max="survey.options.outOfFive ? 5 : 10"
                          v-model="selectedTriggerRangeValue"
                          :disabled="field.hasTriggerEnabled || (field.triggeredBy && field.triggeredBy.length > 0)"
                        />
                        <div class="btn-group">
                          <button
                            class="btn btn-secondary"
                            @click="setRangeTrigger(field, selectedTriggerField, selectedTriggerRangeValue)"
                            v-if="!field.triggeredBy || field.triggeredBy.length === 0"
                          >
                            Enable
                          </button>
                          <button class="btn btn-secondary btn-danger" @click="disableTrigger(field)" v-else>
                            Disable
                          </button>
                        </div>
                      </div>
                      <div
                        v-if="selectedTriggerField.type == 'checkbox' || selectedTriggerField.type == 'radiobutton'"
                      >
                        <label for="select-trigger-answer-options">is equal to</label>
                        <select
                          id="select-trigger-answer-options"
                          v-model="selectedTriggerAnswerOption"
                          :disabled="field.hasTriggerEnabled || (field.triggeredBy && field.triggeredBy.length > 0)"
                        >
                          <option
                            v-for="answerOption in selectedTriggerField.answerOptions"
                            :value="answerOption.uuid"
                          >
                            {{ answerOption.value }}
                          </option>
                        </select>
                        <button
                          class="btn btn-secondary"
                          @click="setOptionTrigger(field, selectedTriggerField)"
                          v-if="!field.triggeredBy || field.triggeredBy.length === 0"
                        >
                          Enable
                        </button>
                        <button class="btn btn-secondary btn-danger" @click="disableTrigger(field)" v-else>
                          Disable
                        </button>
                      </div>
                    </div>
                    <p class="readable-text mt-2">
                      You can only use Radio, Checkbox or Range fields for adding conditions. In order to use a field
                      for a condition, it must be placed before the current field.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Field Preview -->
              <div class="field-preview mt-3 text-center">
                <h5 class="header-case" v-if="field.mode == 'edit' || field.mode == 'create'">
                  {{ __('PREVIEW') }}
                  <small>({{ __('This is what Guests will see') }})</small>
                </h5>
                <field-selector
                  :outOfFive="survey.options.outOfFive && !field.isNps"
                  :colors="colorValues"
                  :field="field"
                  :preview="true"
                ></field-selector>
              </div>

              <!-- Field Actions -->
              <div
                class="field-actions d-flex justify-content-center"
                v-if="field.mode == 'edit' || field.mode == 'create'"
              >
                <button class="btn btn-trans" @click="cancelQuestion(index)" v-if="field.mode == 'create'">
                  {{ __('CANCEL QUESTION') }}
                </button>
                <button class="btn btn-trans" @click="cancelChanges(index)" v-if="field.mode == 'edit'">
                  {{ __('CANCEL CHANGES') }}
                </button>
                <button class="btn btn-primary" @click="saveQuestion(index)">
                  {{ __('SAVE QUESTION') }}
                </button>
              </div>
            </div>

            <div slot="footer" class="drop-section fields-drop-section" v-if="survey.fields.length == 0">
              <div class="dragging">
                <p class="text-center">
                  <img src="/assets/img/1.0/dropping.png" alt="Drop" />
                </p>
                <p class="text-center thin-title">Drop question <strong>here</strong>.</p>
              </div>
              <div class="waiting">
                <div class="drop-section-instructions">
                  <p class="text-center">
                    <img src="/assets/img/1.0/dropzone.png" alt="Drop" />
                  </p>
                  <p class="text-center thin-title">
                    {{ __('Drag and drop questions here in order to start designing your survey') }}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="survey.fields.length != 0">
                <div class="title px-2">
                  <strong>{{ __('Submission Fields') }}</strong>
                </div>
                <div class="team-actions mt-4 mb-4 d-flex flex-md-row flex-column justify-content-between">
                  <div class="col px-2">
                    <div>
                      <label class="typo__label">Select what to be shown</label>
                      <multiselect
                        open-direction="top"
                        v-model="fieldsShown"
                        :options="fields"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Select"
                        label="label"
                        track-by="value"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }"
                          ><span class="multiselect__single" v-if="values.length && !isOpen"
                            >{{ values.length }} options selected</span
                          ></template
                        >
                      </multiselect>
                    </div>
                  </div>
                  <br />
                  <div class="col px-2">
                    <div>
                      <label class="typo__label">Select what to be required</label>
                      <multiselect
                        open-direction="top"
                        v-model="fieldsRequired"
                        :options="fieldsShown"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Select"
                        label="label"
                        track-by="value"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }"
                          ><span class="multiselect__single" v-if="values.length && !isOpen"
                            >{{ values.length }} options selected</span
                          ></template
                        >
                      </multiselect>
                    </div>
                  </div>
                </div>
                <br />
              </div>
          </draggable>
          <div class="survey-options" v-show="currentStep == builderSteps.emailConfigStep">
              <div class="survey-option">
                <div class="option-head">
                  <strong class="option-title">{{ __('Your e-mail subject') }}</strong>
                  <span
                    class="characters"
                    :class="{
                      'text-danger':
                        this.survey.options.emailSubject.length < 5 || this.survey.options.emailSubject.length > 78,
                    }"
                    >{{ survey.options.emailSubject.length }}/78</span
                  >
                </div>
                <div class="option-input">
                  <input
                    type="text"
                    v-model="survey.options.emailSubject"
                    placeholder="Enter a subject for the survey e-mail"
                  />
                </div>
              </div>
              <div class="survey-option">
                <div class="option-head">
                  <strong class="option-title">{{ __('Your e-mail message here') }}</strong>
                  <span
                    class="characters"
                    :class="{
                      'text-danger':
                        this.survey.options.emailBody.length < 30 || this.survey.options.emailBody.length > 3000,
                    }"
                    >{{ survey.options.emailBody.length }}/3000</span
                  >
                </div>
                <div class="option-input" style="height: 300px">
                  <ckeditor :editor="editor" :config="editorConfig" v-model="survey.options.emailBody" @ready="onReady">
                  </ckeditor>
                </div>
                <div class="option-info mt-3">
                  <h4 class="header-case">
                    {{ __('Survey Placeholders') }}
                  </h4>
                  <p class="readable-text">
                    {{
                      __(
                        'You can use these placeholders within the Email text. These values will be automatically replaced when the survey is sent out',
                      )
                    }}
                  </p>
                  <ul>
                    <li>
                      <strong>[OPTIMAL_GUEST_NAME]</strong>
                      -
                      {{ __('GuestFlip will use the best name or title for the Guest') }}
                    </li>
                    <li>
                      <strong>[HOTEL_NAME]</strong> -
                      {{ __("Your Hotel's name as it appears on GuestFlip") }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="survey-options" v-show="currentStep == builderSteps.actionsStep">
              <div class="survey-option mb-4">
                <div class="option-head mb-4">
                  <strong class="option-title">{{ __('Thank you message') }}</strong>
                  <span
                    class="characters"
                    :class="{
                      'text-danger':
                        this.survey.options.thankYouText.length < 5 || this.survey.options.thankYouText.length > 500,
                    }"
                    >{{ survey.options.thankYouText.length }}/500</span
                  >
                </div>
                <div class="option-input mb-4">
                  <textarea
                    maxlength="500"
                    v-model="survey.options.thankYouText"
                    placeholder="Enter a text to appear after the survey submission"
                  />
                </div>
              </div>

              <div class="survey-option mb-4">
                <div class="option-head mb-4">
                  <strong class="option-title">{{ __('CTA Text') }}</strong>
                  <span
                    class="characters"
                    :class="{
                      'text-danger': this.survey.options.ctaText.length < 2 || this.survey.options.ctaText.length > 200,
                    }"
                    >{{ survey.options.ctaText.length }}/200</span
                  >
                </div>
                <div class="option-input mb-4">
                  <textarea
                    maxlength="500"
                    v-model="survey.options.ctaText"
                    placeholder="Enter a text to appear after the survey submission"
                  />
                </div>
              </div>

              <div class="survey-option mb-4">
                <strong class="option-title">{{
                  __('Would you like to redirect your guests to another page after they fill the survey?')
                }}</strong>

                <div class="btn-group mt-4 mb-4" role="group" aria-label="First group">
                  <button
                    type="button"
                    class="btn btn-tab-group"
                    v-on:click="removeRedirectAction"
                    v-bind:class="{
                      'btn-primary': !survey.actions.length,
                    }"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    class="btn btn-tab-group"
                    v-on:click="addRedirectAction"
                    v-bind:class="{
                      'btn-primary': survey.actions.length,
                    }"
                  >
                    Yes
                  </button>
                </div>
                <div class="col-md-12" style="border-left: 5px #0780bb solid" v-if="survey.actions.length">
                  <div class="option-head">
                    <strong class="option-title"
                      >{{ __('Where would you like to redirect your guests to?') }}
                      <i
                        class="fas fa-info info-circle align-middle"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="This will serve as a default link for any rule that isnt matched to the guest."
                      ></i>
                    </strong>
                  </div>
                  <div class="option-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Enter a valid url"
                      v-model="survey.actions[0].action"
                      :class="{ 'is-invalid': !isURLValid }"
                    />
                    <div v-if="!isURLValid" class="invalid-feedback">
                      Please enter a valid URL. (Starting with https:// or http://)
                    </div>
                    <br />
                  </div>
                  <div class="option-head">
                    <strong class="option-title">{{
                      __('After how many seconds would you like to redirect the guest to the page?')
                    }}</strong>
                  </div>
                  <div class="option-input">
                    <input type="number" class="form-control" v-model="survey.actions[0].delay" />
                  </div>

                  <div class="option-head">
                    <strong class="option-title"
                      >{{ __("Don't redirect if the score of the questions is lower than") }}
                      <i
                        class="fas fa-info info-circle align-middle"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="This value represents the average score of the questions. If the score is lower than this value, the guest will not be redirected to the page."
                      ></i>
                    </strong>
                  </div>
                  <div class="option-input">
                    <b-form-slider
                      :min="1"
                      :max="100"
                      :step="1"
                      v-on:change="setCriterionValue($event, survey.actions[0].criteria[0])"
                      :value="parseInt(survey.actions[0].criteria[0].value)"
                    />
                    <span class="ml-3">{{ survey.actions[0].criteria[0].value / 10 }}</span>
                  </div>
                  <br />
                  <!-- COUNTRIES -->
                  <div class="mt-2" v-if="showCountries">
                    <div class="option-head">
                      <strong class="option-title">Edit the link for each Country</strong>
                    </div>
                    <tags-input
                      v-model="selectedCountries"
                      :placeholder="__('Add a country')"
                      :existing-tags="countries"
                      :typeahead-max-results="10"
                      :typeahead="true"
                      :validate="validateCountryTag"
                      @tag-removed="cascadeRemoveAction"
                    >
                      <template v-slot:selected-tag="{ tag, index, removeTag }">
                        <div :class="tag.invalidLink ? 'text-danger' : null">
                          <span v-html="tag.value"></span>

                          <a href="#" class="tags-input-edit fa fa-edit" @click.prevent="openModalCountry(tag)"></a>
                          <a
                            href="#"
                            class="tags-input-remove"
                            @click.prevent="
                              () => {
                                removeTag(index);
                              }
                            "
                          ></a>
                        </div>
                      </template>
                    </tags-input>
                    <br />
                  </div>
                  <button type="button" class="btn btn-primary btn-sm" @click="toggleCountries">
                    {{ toggleCountriesButtonText }}
                  </button>
                  <!-- COUNTRIES END -->

                  <!-- LANGUAGES -->
                  <div>
                    <div class="mt-2" v-if="showLanguages">
                      <div class="option-head">
                        <strong class="option-title">Edit the link for each Language</strong>
                      </div>
                      <tags-input
                        v-model="selectedLanguages"
                        :placeholder="__('Add a language')"
                        :existing-tags="languages"
                        :typeahead-max-results="10"
                        :typeahead="true"
                        :validate="validateLanguageTag"
                        @tag-removed="cascadeRemoveAction"
                      >
                        <template v-slot:selected-tag="{ tag, index, removeTag }">
                          <div :class="tag.invalidLink ? 'text-danger' : null">
                            <span v-html="tag.value"></span>

                            <a href="#" class="tags-input-edit fa fa-edit" @click.prevent="openModalLanguage(tag)"></a>
                            <a
                              href="#"
                              class="tags-input-remove"
                              @click.prevent="
                                () => {
                                  removeTag(index);
                                }
                              "
                            ></a>
                          </div>
                        </template>
                      </tags-input>
                    </div>
                    <br />
                    <button type="button" class="btn btn-primary btn-sm" @click="toggleLanguages">
                      {{ toggleLanguagesButtonText }}
                    </button>
                    <br />
                  </div>
                  <!-- LANGUAGES END -->
                </div>
              </div>

              <div class="survey-option mb-4">
                <strong class="option-title">{{
                  __('Add "Subscribe To Newsletter" button on survey "Thank You page?')
                }}</strong>
                <div class="btn-group mt-4 mb-4" role="group" aria-label="First group">
                  <button
                    type="button"
                    class="btn btn-tab-group"
                    v-on:click="removeSubscribeAction"
                    v-bind:class="{
                      'btn-primary': Object.keys(survey.subscribe).length === 0,
                    }"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    class="btn btn-tab-group"
                    v-on:click="addSubscribeAction"
                    v-bind:class="{
                      'btn-primary': Object.keys(survey.subscribe).length > 0,
                    }"
                  >
                    Yes
                  </button>
                </div>
                <div
                  class="col-md-12"
                  style="border-left: 5px #0780bb solid"
                  v-if="Object.keys(survey.subscribe).length > 0"
                >
                  <div class="option-head">
                    <strong class="option-title">{{
                      __('Where would you like to redirect your guests to for subscribing to newsletter?')
                    }}</strong>
                  </div>
                  <div class="option-input">
                    <input type="text" placeholder="Enter a valid url" v-model="survey.subscribe.url" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 fields-col" v-if="$global.isMobile==false">
        <div class="card card-fields" v-if="currentStep == builderSteps.surveyFieldsStep">
          <div class="card-header">
            <h5 class="header-title text-center">
              {{ __('TYPES OF QUESTIONS') }}
            </h5>
          </div>
          <div class="card-body">
            <draggable
              class="dragArea list-group survey-item-draggable"
              :list="availableFields"
              ghost-class="ghost-element"
              :group="{
                name: 'fields',
                pull: 'clone',
                put: false,
              }"
              @change="addNew"
              @start="dragStart"
              @end="dragEnd"
            >
              <li class="draggable" v-for="fieldName in availableFields" :key="fieldName">
                <div class="d-flex justify-content-between">
                  <div class="field-icons">
                    <div class="field-icon-main">
                      <img :src="fieldImage(fieldName)" :alt="fieldName" />
                    </div>
                    <a
                      class="preview-field"
                      href="#"
                      @mouseover="previewField(fieldName)"
                      @click.prevent="editPreviewField"
                      @mouseout="removePreviewField"
                    >
                      <img src="/assets/img/1.0/preview.png" alt="Preview" class="base" />
                      <img src="/assets/img/1.0/preview-hover.png" alt="Preview" class="hover" />
                      <span>{{ __('Preview Type') }}</span>
                    </a>
                  </div>
                  <div class="field-description">
                    <p class="light-text field-label">
                      {{ __('QUESTION TYPE') }}
                    </p>
                    <p class="strong-paragraph">
                      {{ __(labelize(fieldName)) }}
                    </p>
                    <span class="blue-text text-right">
                      DRAG QUESTION
                      <img src="/assets/img/1.0/drag.png" alt="Drag" />
                    </span>
                  </div>
                </div>
              </li>
            </draggable>
          </div>
        </div>
 
        <div class="card card-styling" v-if="currentStep == builderSteps.stylingStep">
          <div class="card-header border-bottom">
            <h5 class="header-title text-center">
              {{ __('STYLING OPTIONS') }}
            </h5>
          </div>
          <div class="card-body">
            <!-- STYLING SECTIONS -->
            <div class="styling-section border-bottom mb-3">
              <div class="styling-section-head">
                <h5 class="bold">Colors</h5>
                <div class="actions">
                  <a href="#" class="light-text" @click.prevent="">RESET</a>
                </div>
              </div>
              <div class="styling-section-options">
                <div class="styling-section-option-name">
                  {{ __('Highlight color') }}
                </div>
                <div
                  class="styling-section-option-value"
                  :class="{
                    'extension-active': colors.highlightColor.editMode,
                  }"
                >
                  <span class="color-element" @click="clickColors($event, colors.highlightColor)">
                    <span
                      class="color-preview"
                      :style="{
                        'background-color': colors.highlightColor.value.hex,
                      }"
                    ></span>
                    <span class="color-text">{{ colors.highlightColor.value.hex }}</span>
                  </span>
                  <div class="color-picker-wrapper" data-color-id="highlightColor" v-click-outside="disableColors">
                    <chrome-picker v-model="colors.highlightColor.value"></chrome-picker>
                  </div>
                </div>
              </div>
              <div class="styling-section-options">
                <div class="styling-section-option-name">
                  {{ __('Primary text color') }}
                </div>
                <div
                  class="styling-section-option-value"
                  :class="{
                    'extension-active': colors.baseColor.editMode,
                  }"
                >
                  <span class="color-element" @click="clickColors($event, colors.baseColor)">
                    <span
                      class="color-preview"
                      :style="{
                        'background-color': colors.baseColor.value.hex,
                      }"
                    ></span>
                    <span class="color-text">{{ colors.baseColor.value.hex }}</span>
                  </span>
                  <div class="color-picker-wrapper" data-color-id="baseColor" v-click-outside="disableColors">
                    <chrome-picker v-model="colors.baseColor.value"></chrome-picker>
                  </div>
                </div>
              </div>
              <div class="styling-section-options">
                <div class="styling-section-option-name">
                  {{ __('Secondary text color') }}
                </div>
                <div
                  class="styling-section-option-value"
                  :class="{
                    'extension-active': colors.secondaryColor.editMode,
                  }"
                >
                  <span class="color-element" @click="clickColors($event, colors.secondaryColor)">
                    <span
                      class="color-preview"
                      :style="{
                        'background-color': colors.secondaryColor.value.hex,
                      }"
                    ></span>
                    <span class="color-text">{{ colors.secondaryColor.value.hex }}</span>
                  </span>
                  <div class="color-picker-wrapper" data-color-id="secondaryColor" v-click-outside="disableColors">
                    <chrome-picker v-model="colors.secondaryColor.value"></chrome-picker>
                  </div>
                </div>
              </div>
            </div>
            <!-- /> STYLING SECTION -->
            <!--            <div class="styling-section">-->
            <!--              <div class="styling-section-head">-->
            <!--                <h5 class="bold">Fonts</h5>-->
            <!--                <div class="actions">-->
            <!--                  <a href="#" class="light-text" @click.prevent="">RESET</a>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div class="styling-section-options">-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <div v-else>
        <div class="mobile-draggable-wrapper" v-if="currentStep == builderSteps.surveyFieldsStep">
          <draggable
            class="mobile-draggable-icons"
            :list="availableFields"
            ghost-class="ghost-element"
            :group="{ name: 'fields', pull: 'clone', put: false }"
            @change="addNew"
            @start="dragStart"
            @end="dragEnd"
          >
            <div
              class="mobile-circle-icon"
              v-for="fieldName in availableFields"
              :key="fieldName"
            >
              <img :src="fieldImage(fieldName)" :alt="fieldName" />
            </div>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SurveysService from '../../services/surveys-service';
import Vue from 'vue';
import draggable from 'vuedraggable';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { v4 as uuidv4 } from 'uuid';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import 'bootstrap-slider/dist/css/bootstrap-slider.css';
import Multiselect from 'vue-multiselect';
import * as _ from 'lodash';
import GeoMappingsService from '../../services/geomappings-service';
import LangMappingsService from '../../services/langmappings-service';
export default {
  components: {
    draggable,
    ckeditor: CKEditor.component,
    Multiselect,
  },
  props: {
    autocompleteItems: {
      type: Array,
      validator: function (value) {
        return value.every((item) => {
          return typeof item === 'object' && item.name && typeof item.name === 'string';
        });
      },
      default: function () {
        return [];
      },
    },
  },
  computed: {
    surveyModified() {
      // Ensure originalSurvey is not null before comparing
      if (this.originalSurvey) {
        // Check if the current survey object is the same as the original survey object
        return !_.isEqual(this.survey, this.originalSurvey);
      }
      return false;
    },
    isURLValid() {
      const urlRegex = /^(http|https):\/\/[^ "]+$/;
      return urlRegex.test(this.survey.actions[0].action);
    },
    toggleLanguagesButtonText() {
      return this.showLanguages ? 'Hide Languages' : 'Show Languages';
    },
    toggleCountriesButtonText() {
      return this.showCountries ? 'Hide Countries' : 'Show Countries';
    },
    infoFields() {
      return this.fieldsShown.map((field) => {
        const required = this.fieldsRequired.some((requiredField) => requiredField.name === field.name);
        return {
          value: field.value,
          required,
        };
      });
    },
    isPreviewVisible() {
      return (
        this.currentStep == this.builderSteps.surveyFieldsStep || this.currentStep == this.builderSteps.stylingStep
      );
    },
    stepTitle() {
      switch (this.currentStep) {
        case 1:
          return 'Select survey images';
        case 2:
          return 'Set up fields';
        case 3:
          return 'Apply your styling';
        case 4:
          return 'Configure the e-mail';
        case 5:
          return 'Setup after submit actions';
        case 6:
          return 'Select sending options';
      }
    },
    isInEditMode() {
      let editMode = false;

      for (let field of this.survey.fields) {
        if (field.mode == 'edit') {
          editMode = true;
          break;
        }
      }

      return editMode;
    },
    colorValues() {
      return {
        highlightColor: this.colors.highlightColor.value.hex,
        baseColor: this.colors.baseColor.value.hex,
        secondaryColor: this.colors.secondaryColor.value.hex,
      };
    },
    activeColor() {
      let foundColor = false;

      for (let color in this.colors) {
        if (this.colors[color].editMode == true) {
          foundColor = color;
        }
      }

      return foundColor;
    },
    isScrolling() {
      let val = this.survey.fields.length;
      if (!this.$refs.preview_body) return false;

      if (this.$refs.preview_body.scrollHeight > 500) {
        return true;
      }

      return false;
    },
    currentPreviewField() {
      let fields = this.survey.fields.filter((element) => {
        return element.mode == 'temporary_preview';
      });

      if (fields.length == 0) return null;

      return fields[0];
    },
  },
  data() {
    return {
      isSaving: true,
      originalSurvey: null,
      originalFieldsRequired: null,
      originalFieldsShown: null,
      minAverage: 20,
      defaultDelay: 9,
      tagLanguage: '',
      tagCountry: '',
      countries: [],
      selectedCountries: [],
      showCountries: false,
      languages: [],
      selectedLanguages: [],
      showLanguages: false,
      fieldsShown: [],
      fieldsRequired: [],
      fields: [
        {
          label: 'First Name',
          value: 'first_name'
        },
        {
          label: 'Last Name',
          value: 'last_name'
        },
        {
          label: 'Email',
          value: 'email'
        },
        {
          label: 'Room Number',
          value: 'room_number'
        },
        {
          label: 'Nationality',
          value: 'nationality_code'
        },
        {
          label: 'Check In Date',
          value: 'check_in_date'
        },
        {
          label: 'Check Out Date',
          value: 'check_out_date'
        },
        {
          label: 'Phone Number',
          value: 'phone_number'
        },
      ],
      editor: ClassicEditor,
      editorConfig: {
        removePlugins: ['Autoformat', 'ImageUpload', 'EasyImage', 'MediaEmbed', 'Highlight'],
        toolbar: {},
        allowedContent: true,
      },
      ruleEnabled: false,
      expiryEnabled: false,
      value: null,
      dragging: false,
      topics: [],
      internalId: 1,
      colors: {
        highlightColor: {
          value: {
            hex: '#00afef',
          },
          editMode: false,
        },
        baseColor: {
          value: {
            hex: '#2c2d4a',
          },
          editMode: false,
        },
        secondaryColor: {
          value: {
            hex: '#9596a3',
          },
          editMode: false,
        },
      },
      currentStep: 1,
      builderSteps: {
        surveyImagesStep: 1,
        surveyFieldsStep: 2,
        stylingStep: 3,
        emailConfigStep: 4,
        actionsStep: 5,
        sendingOptionsStep: 6,
      },
      mode: 'edit',
      titleEditable: false,
      actionTypes: [
        {
          key: 'redirect',
          name: 'Redirect',
        },
      ],
      ruleTypes: [
        {
          key: 'before_checkout',
          name: 'After Check-in',
        },
        {
          key: 'after_checkout',
          name: 'After Check-out',
        },
      ],
      visible: {
        questionTypes: true,
        options: false,
        texts: false,
        emails: false,
        rules: false,
        actions: false,
      },
      dragOptions: {
        dropzoneSelector: '.fields-drop-section',
        draggableSelector: '.draggable',
        handlerSelector: null,
        ghostClass: 'ghost-element',
        reactivityEnabled: true,
        multipleDropzonesItemsDraggingEnabled: true,
        showDropzoneAreas: true,
        onDrop: function (event) {},
        onDragstart: (event) => {
          this.dragStart(event);
        },
        onDragend: (event) => {
          this.dragEnd(event);
        },
      },
      surveyIsNew: false,
      mockSurvey: {
        loaded: false,
        title: '',
        description: 'Description of survey',
        fields: [],
        infoFields: {},
        options: {
          font: 'sans-serif',
          emailSubject: '',
          emailBody: '',
          outOfFive: false,
          baseColor: '#8f5c43',
          secondaryColor: '#40e4c7',
          titleFontSize: 25,
          descriptionFontSize: 18,
          textFontSize: 13,
          bottomText: null,
          thankYouText: 'Thank you for filling our survey. We really appreciate your feedback.',
          ctaText: 'Share your thoughts',
          acceptTermsText: null,
          acceptMarketingText: 'Provident ut eum veritatis iusto ea.',
        },
        actions: [],
        rules: [],
        subscribe: {},
      },
      availableFields: ['range', 'radiobutton', 'checkbox', 'text', 'explanation'],
      availableSurveyImages: [],
      customBrandingLogoImage: null,
      customBrandingMainImage: null,
      triggerOptionsExpand: null,
      selectedTriggerField: null,
      selectedTriggerRangeValue: 6,
      selectedTriggerAnswerOption: null,
      survey: {
        infoFields: {},
        fields: [],
        images: {
          logo: '',
          main: '',
        },
        options: {
          emailSubject: '',
          emailBody: '<p>Dear [OPTIMAL_GUEST_NAME]</p>',
          thankYouText: '',
          ctaText: '',
        },
        actions: [],
        subscribe: {},
      },
      nextElement: 0,
      activeOptions: null,
      avoidCanceling: false,
    };
  },
  created() {
    if (!this.isSaving) {
      window.addEventListener('beforeunload', (e) => {
        if (this.surveyModified) {
          e.preventDefault();
          const message = 'You have unsaved changes. Are you sure you wish to leave?';
          e.returnValue = message;
          return message;
        }
      });
    }
  },
  async mounted() {
    this.getTopics();
    let id = window.location.href.split('/').slice(-2)[0];

    const urlParams = new URLSearchParams(window.location.search);
    const baseId = urlParams.get('base');

    if (baseId) {
      this.getDuplicate(baseId);
    }

    this.countries = GeoMappingsService.getCountries();

    this.availableSurveyImages = await SurveysService.getAvailableSurveyImages(id);

    if (id == 'surveys') {
      id = window.location.href.split('/').slice(-1)[0];
      this.surveyIsNew = true;
      Vue.set(this, 'survey', this.mockSurvey);
      this.toggleSurveyTitleEditable(true);

      this.$nextTick(function () {
        this.$refs.survey_title_input.focus();
      });
    } else {
      Vue.set(this, 'survey', this.prepareSurvey(await SurveysService.get(id)));
    }

    this.mapSurveyLocales();
    this.loadSelectedActions();
    this.ensureAnswerOptionsOrder();
},
  watch: {
    selectedLanguages: {
      handler: 'checkForLanguageLink',
      immediate: true,
    },
    selectedCountries: {
      handler: 'checkForCountryLink',
      immediate: true,
    },
    'survey.loaded': {
      handler(newVal) {
        if (newVal) {
          // Save the initial state of the survey object when it's loaded
          this.originalSurvey = _.cloneDeep(this.survey);
          this.originalFields = _.cloneDeep(this.fields);
          this.originalFieldsRequired = _.cloneDeep(this.fieldsRequired);
          this.originalFieldsShown = _.cloneDeep(this.fieldsShown);
        }
      },
      immediate: true,
    },
  },
  methods: {
    // triggerFieldRelatedToRange(field) {
    //     const uuids = []
    //     field.answerOptions.forEach(option => {
    //         if (option.value < 7) {
    //             uuids.push(option.uuid)
    //         }
    //     })

    //     const fieldIndex = this.getFieldIndex(field)

    //     if (field.hasTriggerEnabled) {
    //         this.survey.fields[fieldIndex].hasTriggerEnabled = false
    //         return this.removeField(fieldIndex + 1)
    //     }

    //     this.addNewField('text', fieldIndex + 1)
    //     this.survey.fields[fieldIndex + 1].title = 'Field triggered by 6 or lower'
    //     this.survey.fields[fieldIndex + 1].triggeredBy = uuids

    //     this.survey.fields[fieldIndex].hasTriggerEnabled = true
    // },
    ensureAnswerOptionsOrder() {
        this.survey.fields.forEach((field) => {
            if (field.answerOptions && Array.isArray(field.answerOptions)) {
                field.answerOptions.forEach((option, index) => {
                    option.order = index; 
                });
            }
        });
    },
    updateAnswerOrder(field) {
      field.answerOptions.forEach((answer, index) => {
        answer.order = index;
      });
    },
    checkForLanguageLink() {
      this.selectedLanguages.forEach((tag) => {
        if (!tag.link || tag.link === '') {
          tag.invalidLink = true;
        }
      });
    },
    checkForCountryLink() {
      this.selectedCountries.forEach((tag) => {
        if (!tag.link || tag.link === '') {
          tag.invalidLink = true;
        }
      });
    },
    cascadeRemoveAction({ key, value, link }) {
      const idx = this.survey.actions.findIndex((action) => {
        return action.action == link && action.criteria.find((criteria) => criteria.value == key) !== undefined;
      });
      if (idx > -1) {
        this.survey.actions.splice(idx, 1);
      }
    },

    mapSurveyLocales() {
      if (!this.survey.locales) {
        this.languages = [
          {
            key: 'en',
            value: 'English',
          },
        ];
        return;
      }

      const locales = this.survey.locales.map((locale) => {
        return {
          key: locale.code,
          value: locale.name,
        };
      });

      this.languages = locales;
    },

    loadSelectedActions() {
      this.survey.actions.forEach((action) => {
        if (action.type === 'redirect') {
          const actionType = action.criteria.filter((criteria) => criteria.type !== 'min_average')?.[0]?.type;
          if (!actionType) {
            return;
          }

          const criterion = action.criteria.find(
            (criteria) => criteria.type === 'country' || criteria.type === 'language',
          );
          const key = criterion.value;
          const minAverage = action.criteria.find((criteria) => criteria.type === 'min_average').value;
          switch (actionType) {
            case 'country':
              this.selectedCountries.push({
                id: action.id,
                key: key,
                value: GeoMappingsService.alpha2(key),
                link: action.action,
                minAverage: minAverage,
              });
              break;
            case 'language':
              this.selectedLanguages.push({
                id: action.id,
                key: key,
                value: LangMappingsService.alpha3(key),
                link: action.action,
                minAverage: minAverage,
              });
              break;
          }
        }
      });
    },

    saveCountries(defaultDelay, minAverage) {
      this.selectedCountries.forEach((country) => {
        // Skip countries that have no link
        if (!country.link) {
          return;
        }
        // Check if there's an existing action with the same country criteria
        const existingAction = this.survey.actions.find((action) => {
          const criteria = action.criteria.find(
            (criteria) => criteria.type === 'country' && criteria.value === country.key,
          );
          return criteria !== undefined;
        });
        if (existingAction) {
          // Update the existing action's link
          existingAction.action = country.link;
          existingAction.criteria.find((criteria) => criteria.type === 'min_average').value =
            Number(minAverage).toFixed(0);
          existingAction.delay = defaultDelay;
        } else {
          // Create a new action for the country
          const newAction = {
            time: 'after',
            type: 'redirect',
            action: country.link,
            delay: defaultDelay,
            order: this.survey.actions.length,
            criteria: [
              {
                type: 'country',
                value: country.key,
              },
              {
                type: 'min_average',
                value: minAverage,
              },
            ],
          };
          this.survey.actions.push(newAction);
        }
      });
    },
    saveLanguages(defaultDelay, minAverage) {
      this.selectedLanguages.forEach((language) => {
        if (!language.link) {
          return;
        }
        // Check if there's an existing action with the same language criteria
        const existingAction = this.survey.actions.find((action) => {
          const criteria = action.criteria.find(
            (criteria) => criteria.type === 'language' && criteria.value === language.key,
          );
          return criteria !== undefined;
        });
        if (existingAction) {
          // Update the existing action's link
          existingAction.action = language.link;
          existingAction.criteria.find((criteria) => criteria.type === 'min_average').value =
            Number(minAverage).toFixed(0);
          existingAction.delay = defaultDelay;
        } else {
          // Create a new action for the language
          const newAction = {
            time: 'after',
            type: 'redirect',
            action: language.link,
            delay: defaultDelay,
            order: this.survey.actions.length,
            criteria: [
              {
                type: 'language',
                value: language.key,
              },
              {
                type: 'min_average',
                value: minAverage,
              },
            ],
          };
          this.survey.actions.push(newAction);
        }
      });
    },

    toggleCountries() {
      this.showCountries = !this.showCountries;
    },

    toggleLanguages() {
      this.showLanguages = !this.showLanguages;
    },

    validateCountryTag(tag) {
      const noNumbersRegex = /^([^0-9]*)$/;
      const minLengthRegex = /^.{3,}$/;
      const countryExists = GeoMappingsService.alpha2(tag.value) !== undefined;

      const allRulesPass = noNumbersRegex.test(tag.text) && minLengthRegex.test(tag.text) && countryExists;

      return allRulesPass;
    },

    validateLanguageTag(tag) {
      const noNumbersRegex = /^([^0-9]*)$/;
      const minLengthRegex = /^.{3,}$/;
      const languageExists = LangMappingsService.alpha3(tag.value) !== undefined;

      const allRulesPass = noNumbersRegex.test(tag.text) && minLengthRegex.test(tag.text) && languageExists;

      return allRulesPass;
    },

    //Retrieves the Delay value from the action object and if it's empty assigns it a default value
    getDelayLanguage(tag) {
      const action = this.survey.actions.find((action) => {
        const criteria = action.criteria.find((criteria) => criteria.type === 'language' && criteria.value === tag.key);
        return criteria !== undefined;
      });

      if (action && action.delay !== undefined) {
        return action.delay;
      }

      return 'Action not found';
    },
    //Retrieves the minAverage value from the action object and if it's empty assigns it a default value
    getMinAverageLanguage(tag) {
      const action = this.survey.actions.find((action) => {
        const criteria = action.criteria.find((criteria) => criteria.type === 'language' && criteria.value === tag.key);
        return criteria !== undefined;
      });
      if (action) {
        const minAverageCriteria = action.criteria.find((criteria) => criteria.type === 'min_average');
        return minAverageCriteria.value;
      }
      return 'Action not found';
    },

    findSurveyAction(type, { key }) {
      const action = this.survey.actions.find((action) => {
        const criteria = action.criteria.find((criteria) => criteria.type === type && criteria.value === key);
        return criteria !== undefined;
      });

      if (!action) {
        return null;
      }

      const criterions = action.criteria.reduce((acc, curr) => {
        acc[curr.type] = curr.value;
        return acc;
      }, {});

      return {
        ...action,
        ...criterions,
      };
    },

    openModalLanguage(tag) {
      //If the tag doesn't have a link, we set it to an empty string in order to avoid showing undefined
      if (tag.link == null) {
        tag.link = '';
      }

      const action = this.findSurveyAction('language', tag);

      const modalContent = /*html*/ `
      <div>
        <div class="form-group">
          <div class="option-head">
            <strong class="option-title"> Enter redirect link: </strong>
          </div>
          <input
            id="redirectLink"
            type="text"
            class="form-control d-block"
            value="${tag.link}"
          />
        </div>
        <div class="form-group">
          <div class="option-head">
            <strong class="option-title">
              After how many seconds would you like to redirect the guest to the page?
            </strong>
          </div>
          <input
            class="form-control d-block"
            id="defaultDelay"
            type="number"
            value="${action?.delay ?? 20}"
            min="1"
            max="20"
          />
        </div>
        <div class="form-group">
          <div class="option-head">
            <strong class="option-title">
              Don't redirect if the score of the questions is lower than
            </strong>
          </div>
          <input
            class="form-control d-block"
            id="minAverage"
            type="range"
            value="${action?.min_average ?? 10}"
            min="1"
            max="100"
            step="0.1"
            oninput="document.querySelector('#minAverageDisplay').textContent = (this.value/10).toFixed(1);"
          />
          <span id="minAverageDisplay"
            >${((action?.min_average ?? 20) / 10).toFixed(1)}</span
          >
        </div>
      </div>
      `;
      swal(
        {
          title: `Edit ${tag.value}`,
          html: true,
          text: modalContent,
          showCancelButton: true,
          confirmButtonText: 'Save',
          cancelButtonText: 'Cancel',
          closeOnConfirm: false,
        },
        () => {
          const link = $('#redirectLink').val();
          const defaultDelay = $('#defaultDelay').val();
          const minAverage = $('#minAverage').val();

          // Validate the delay
          const delay = parseInt(defaultDelay);
          if (isNaN(delay) || delay < 1 || delay > 20) {
            swal.showInputError('Please enter a valid delay between 1 and 20');
            return false;
          }
          //Validate the link
          if (link === false) return false;
          if (link === '') {
            swal.showInputError('Please enter a redirect link');
            return false;
          }
          // Check for valid link format
          const linkRegex = /^https?:\/\/.+/;
          if (!linkRegex.test(link)) {
            swal.showInputError('Please enter a valid link format (starting with http or https)');
            return false;
          }

          // Check for specific invalid links
          const invalidLinks = ['https://', 'http://', 'https://www', 'http://www'];
          if (invalidLinks.includes(link)) {
            swal.showInputError('Please enter a valid link');
            return false;
          }

          // Call the saveLanguageRedirectLink method with the updated values
          this.saveLanguageRedirectLink(tag, link, defaultDelay, minAverage);
          swal({
            title: 'Success!',
            text: 'The redirect link has been updated.',
            type: 'success',
            timer: 1500,
          });
        },
      );
    },

    saveLanguageRedirectLink(language, link, defaultDelay, minAverage) {
      language.link = link;
      language.invalidLink = false;
      this.saveLanguages(defaultDelay, minAverage);
    },

    openModalCountry(tag) {
      //If the tag doesn't have a link, we set it to an empty string in order to avoid showing undefined
      if (tag.link == null) {
        tag.link = '';
      }

      const action = this.findSurveyAction('country', tag);

      const modalContent = /*html*/ `
      <div>
        <div class="form-group">
          <div class="option-head">
            <strong class="option-title"> Enter redirect link: </strong>
          </div>
          <input
            id="redirectLink"
            type="text"
            class="form-control d-block"
            value="${tag.link}"
          />
        </div>
        <div class="form-group">
          <div class="option-head">
            <strong class="option-title">
              After how many seconds would you like to redirect the guest to the page?
            </strong>
          </div>
          <input
            class="form-control d-block"
            id="defaultDelay"
            type="number"
            value="${action?.delay ?? 20}"
            min="1"
            max="20"
          />
        </div>
        <div class="form-group">
          <div class="option-head">
            <strong class="option-title">
              Don't redirect if the score of the questions is lower than
            </strong>
          </div>
          <input
            class="form-control d-block"
            id="minAverage"
            type="range"
            value="${action?.min_average ?? 10}"
            min="1"
            max="100"
            step="0.1"
            oninput="document.querySelector('#minAverageDisplay').textContent = (this.value/10).toFixed(1);"
          />
          <span id="minAverageDisplay"
            >${((action?.min_average ?? 20) / 10).toFixed(1)}</span
          >
        </div>
      </div>
      `;
      swal(
        {
          title: `Edit ${tag.key}`,
          html: true,
          text: modalContent,
          showCancelButton: true,
          confirmButtonText: 'Save',
          cancelButtonText: 'Cancel',
          closeOnConfirm: false,
        },
        () => {
          const link = $('#redirectLink').val();
          const defaultDelay = $('#defaultDelay').val();
          const minAverage = $('#minAverage').val();

          // Validate the delay
          const delay = parseInt(defaultDelay);
          if (isNaN(delay) || delay < 1 || delay > 20) {
            swal.showInputError('Please enter a valid delay between 1 and 20');
            return false;
          }
          //Validate the link
          if (link === false) return false;
          if (link === '') {
            swal.showInputError('Please enter a redirect link');
            return false;
          }
          // Check for valid link format
          const linkRegex = /^https?:\/\/.+/;
          if (!linkRegex.test(link)) {
            swal.showInputError('Please enter a valid link format (starting with http or https)');
            return false;
          }

          // Check for specific invalid links
          const invalidLinks = ['https://', 'http://', 'https://www', 'http://www'];
          if (invalidLinks.includes(link)) {
            swal.showInputError('Please enter a valid link');
            return false;
          }
          // Call the saveCountryRedirectLink method with the updated values
          this.saveCountryRedirectLink(tag, link, defaultDelay, minAverage);
          swal({
            title: 'Success!',
            text: 'The redirect link has been updated.',
            type: 'success',
            timer: 1500,
          });
        },
      );
    },

    saveCountryRedirectLink(country, link, defaultDelay, minAverage) {
      country.link = link;
      country.invalidLink = false;
      this.saveCountries(defaultDelay, minAverage);
    },

    setSurveyImage(type, id) {
      $(`.survey-${type}-available-images img`).removeClass('active');
      $('img[image-id=' + id + ']').addClass('active');
      if (type == 'logo') {
        this.survey.surveyImageLogoId = id;
      } else {
        this.survey.surveyImageMainId = id;
      }
    },

    getSurveyImageUrl(image) {
      let timestamp = image.filename.split('-')[1].replace('.jpg', '');
      return process.env.MIX_API_URL + '/private/' + image.type + '/' + image.teamId + '?t=' + timestamp;
    },

    async getDuplicate(baseId) {
      const baseSurvey = this.prepareSurvey(await SurveysService.get(baseId, true));
      delete baseSurvey.id;
      const map = {};
      for (let i = 0; i < baseSurvey.fields.length; i++) {
        delete baseSurvey.fields[i].id;
        if (!baseSurvey.fields[i].answerOptions) {
          continue;
        }
        for (let y = 0; y < baseSurvey.fields[i].answerOptions.length; y++) {
          delete baseSurvey.fields[i].answerOptions[y].id;
          let newUuid = uuidv4();
          map[baseSurvey.fields[i].answerOptions[y].uuid] = newUuid;
          baseSurvey.fields[i].answerOptions[y].uuid = newUuid;
        }
        delete baseSurvey.fields[i].triggers;
        for (let y = 0; y < baseSurvey.fields[i].triggeredBy.length; y++) {
          baseSurvey.fields[i].triggeredBy[y] = map[baseSurvey.fields[i].triggeredBy[y]];
        }
      }
      for (let i = 0; i < baseSurvey.rules.length; i++) {
        delete baseSurvey.rules[i].id;
      }
      for (let i = 0; i < baseSurvey.actions.length; i++) {
        delete baseSurvey.actions[i].id;
        for (let y = 0; y < baseSurvey.actions[i].criteria.length; y++) {
          delete baseSurvey.actions[i].criteria[y].id;
          delete baseSurvey.actions[i].criteria[y].actionId;
        }
      }
      this.survey = baseSurvey;
    },
    setCustomBrandingLogoImage(value) {
      this.customBrandingLogoImage = value;
    },
    setCustomBrandingMainImage(value) {
      this.customBrandingMainImage = value;
    },
    toggleRangeMode() {
      this.survey.options.outOfFive = !this.survey.options.outOfFive;
    },
    shouldShowTriggerField(oneField, field) {
      if (field.field_id) {
        return oneField.field_id != field.field_id && oneField.order < field.order;
      }

      if (field.id) {
        return oneField.id != field.id && oneField.order < field.order;
      }

      return false;
    },
    triggerOptionExpanded(field) {
      let condition = false;

      if (this.triggerOptionsExpand == null) {
        return false;
      }

      if (field.id) {
        return this.triggerOptionsExpand == field.id;
      }

      // for fields that have yet to be saved
      return this.triggerOptionsExpand == field.field_id;
    },
    getFieldIndex(field) {
      return this.survey.fields.findIndex((internalField) => {
        return internalField.id ? internalField.id === field.id : internalField.field_id === field.field_id;
      });
    },
    getFieldFromAnswerOptionId(optionUuid) {
      let field = this.survey.fields.find(f => f.answerOptions && f.answerOptions.some(a => a.uuid === optionUuid));
      return field
    },
    toggleTriggerOptions(field) {
      if (field.id && field.triggers?.length > 0) {
        let otherField = this.getFieldFromAnswerOptionId(field.triggers[0].uuid);
        this.selectedTriggerField = otherField;
        this.selectedTriggerAnswerOption = field.triggers[0].uuid;
      }

      this.triggerOptionsExpand = this.triggerOptionsExpand !== null ? null : (field.id || field.field_id);
      this.selectedTriggerRangeValue = field.type === 'range' && field.triggers?.length > 0
        ? field.triggers.reduce((max, trigger) => trigger.value > max ? trigger.value : max, 0)
        : 6;
    },
    /**
     * *Must read* to avoid confusion:
     * baseField: The Field that this conditions applies to
     * triggerField: The field that causes the trigger
     */
    setRangeTrigger(baseField, triggerField, value) {
      if (triggerField.order > baseField.order) {
        return;
      }

      let triggers = [];

      for (let answerOption of triggerField.answerOptions) {
        if (parseInt(answerOption.value) <= value) {
          triggers.push(answerOption.uuid);
        }
      }

      let fieldIndex = this.getFieldIndex(baseField);
      this.survey.fields[fieldIndex].hasTriggerEnabled = true;
      this.survey.fields[fieldIndex].triggeredBy = triggers;
    },
    setOptionTrigger(baseField, triggerField) {
      if (triggerField.order > baseField.order) {
        return;
      }

      if (!this.selectedTriggerAnswerOption) {
        return;
      }

      let triggers = [];
      triggers.push(this.selectedTriggerAnswerOption);
      let fieldIndex = this.getFieldIndex(baseField);
      this.survey.fields[fieldIndex].hasTriggerEnabled = true;
      this.survey.fields[fieldIndex].triggeredBy = triggers;
    },
    disableTrigger(baseField) {
      let fieldIndex = this.getFieldIndex(baseField);
      this.survey.fields[fieldIndex].hasTriggerEnabled = false;
      this.survey.fields[fieldIndex].triggeredBy = [];
    },
    triggerFieldRelatedToOption(field) {
      const fieldIndex = this.survey.fields.findIndex((internalField) => {
        return internalField.order === field.order;
      });

      if (field.hasTriggerEnabled) {
        this.survey.fields[fieldIndex].hasTriggerEnabled = false;

        field.answerOptions.forEach((answerOption) => {
          const index = this.survey.fields.findIndex((field) => {
            return field.triggeredBy && field.triggeredBy.includes(answerOption.uuid);
          });

          if (index > -1) this.survey.fields.splice(index, 1);
        });

        return;
      }

      let offset = 1;
      field.answerOptions.forEach((answerOption) => {
        this.addNewField('text', fieldIndex + offset);
        this.survey.fields[fieldIndex + offset].title = 'Field triggered by ' + answerOption.value;
        this.survey.fields[fieldIndex + offset].triggeredBy = [answerOption.uuid];
        offset++;
      });

      this.survey.fields[fieldIndex].hasTriggerEnabled = true;
    },
    setCriterionValue(event, criterion) {
      criterion.value = parseInt(event.newValue);
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    disableKeyPress() {},
    toggleAlertEnabled(answer) {
      answer.alertEnabled = !answer.alertEnabled;
    },
    toggleRule() {
      if (!this.survey.rules || !this.survey.rules.sendingRule) {
        if (!this.survey.rules) {
          this.survey.rules = [];
        }

        this.ruleEnabled = true;
        this.survey.rules.sendingRule = {
          name: 'First Rule',
          afterDays: 2,
          type: 'after_checkout',
          time: 1,
        };
      } else {
        this.ruleEnabled = false;
        this.survey.rules.sendingRule = null;
      }
    },
    toggleExpiry() {
      if (!this.survey.rules || !this.survey.rules.expiryRule) {
        if (!this.survey.rules) {
          this.survey.rules = [];
        }

        this.expiryEnabled = true;
        this.survey.rules.expiryRule = {
          name: 'Expiry Days',
          afterDays: 30,
          type: 'token_expiry',
          time: 1,
        };
      } else {
        this.expiryEnabled = false;
        this.survey.rules.expiryRule = null;
      }
    },
    /**
     * Add a redirect action to the survey
     */
    addRedirectAction() {
      if (this.survey.actions.filter((x) => x.type === 'redirect').length) return false;
      this.survey.actions.push({
        time: 'after',
        type: 'redirect',
        action: '',
        delay: 10,
        order: 0,
        criteria: [
          {
            type: 'min_average',
            value: 1,
          },
        ],
      });
    },

    removeRedirectAction() {
      this.survey.actions = [];
    },
    addSubscribeAction() {
      this.survey.subscribe = {
        url: '',
      };
    },
    removeSubscribeAction() {
      this.survey.subscribe = {};
    },
    labelize(fieldName) {
      switch (fieldName) {
        case 'explanation':
          return 'Instructions';
        case 'range':
          return 'Range';
        case 'radiobutton':
          return 'Radio Options';
        case 'checkbox':
          return 'Checkbox Options';
        case 'text':
          return 'Free Text';
      }
    },
    clickColors(event, color) {
      // disable all colors

      for (let col in this.colors) {
        this.colors[col].editMode = false;
      }

      this.avoidCanceling = true;
      color.editMode = true;
    },
    disableColors(event) {
      // This is a crazy hack, not proud
      let colorId = event.clickedOutsideTarget.getAttribute('data-color-id');

      if (colorId != this.activeColor) {
        return;
      }

      if (this.avoidCanceling) {
        this.avoidCanceling = false;
        return;
      }

      if (!this.activeColor) {
        return;
      }

      this.colors[this.activeColor].editMode = false;
    },
    mapInfoFields(arr) {
      let shownFields = [];
      let requiredFields = [];
      arr.forEach((fieldEntry) => {
        let fields = JSON.parse(fieldEntry.fields);
        fields.map((curField) => {
          curField.label = this.labelizeGeneral(curField.value);
          if (curField.required) {
            requiredFields.push(curField);
          }
          shownFields.push(curField);
        });
      });
      return {
        fields: shownFields,
        required: requiredFields,
      };
    },
    prepareSurvey(survey) {
      const uuids = [];
      survey.fields.forEach((field) => {
        field.mode = 'preview';
        field.errors = [];
        field.triggeredBy = field.triggers ? field.triggers.map((trigger) => trigger.uuid) : [];
        if (field.answerOptions && Array.isArray(field.answerOptions)) {
            field.answerOptions.sort((a, b) => a.order - b.order);
        }
        if (field.triggers) {
            field.triggers.forEach((trigger) => {
                uuids.push(trigger.uuid);
            });
        }
    });

      survey.fields.forEach((field) => {
        field.hasTriggerEnabled =
          field.answerOptions.filter((answerOption) => {
            return uuids.includes(answerOption.uuid);
          }).length > 0;
      });

      const rules = survey.rules || [];
      survey.rules = {};

      rules.forEach((rule) => {
        switch (rule.type) {
          case 'after_checkout':
          case 'after_checkin':
          case 'before_checkin':
          case 'before_checkout':
            survey.rules.sendingRule = { ...rule, time: parseInt(rule.time.split(':')[0]) };
            this.ruleEnabled = true;
            break;
          case 'token_expiry':
            survey.rules.expiryRule = rule;
            this.expiryEnabled = true;
            break;
        }
      });

      survey.actions.forEach((action) => {
        if (!action.criteria.length) {
          action.criteria = [
            {
              type: 'min_average',
              value: 1,
            },
          ];
        }

        return action;
      });

      survey.subscribe = survey.subscribe == null ? {} : survey.subscribe;

      this.colors.baseColor.value.hex = survey.options.baseColor;
      this.colors.secondaryColor.value.hex = survey.options.secondaryColor;
      this.colors.highlightColor.value.hex = survey.options.highlightColor;

      this.customBrandingLogoImage = survey.surveyImageLogoId != null;
      this.customBrandingMainImage = survey.surveyImageMainId != null;

      const { fields, required } = this.mapInfoFields(survey.infoFields);
      this.fieldsShown = fields ? fields : [];
      this.fieldsRequired = required ? required : [];
      survey.loaded = true;

      return survey;
    },
    previousStep() {
      let newStep = this.currentStep - 1;

      if (newStep < 1) {
        newStep = 1;
      }

      this.currentStep = newStep;
    },
    nextStep() {
      let validation = this.validateStep(this.currentStep);

      if (validation.valid) {
        this.currentStep += 1;
      } else {
        swal('Whoops!', validation.message, 'error');
      }
    },
    validateStep(step) {
      switch (step) {
        case 1:
          return this.validateImagesSelected();
        case 2:
          return this.validateAddFields();
        case 3:
          return {
            valid: true,
            message: '',
          };
        case 4:
          return this.validateEmailOptions();
        case 5:
          return {
            valid: true,
            message: '',
          };
      }
    },
    validateEmailOptions() {
      if (this.survey.options.emailSubject.length < 5 || this.survey.options.emailSubject.length > 78) {
        return {
          valid: false,
          message: __('The email subject needs to be between 5 and 50 characters.'),
        };
      }

      if (this.survey.options.emailBody.length < 30 || this.survey.options.emailBody.length > 3000) {
        return {
          valid: false,
          message: __('The email body needs to be between 30 and 3000 characters.'),
        };
      }

      return {
        valid: true,
        message: '',
      };
    },
    validateAddFields() {
      if (this.survey.fields.length == 0) {
        return {
          valid: false,
          message: __('You need to add at least one field'),
        };
      }

      for (let field of this.survey.fields) {
        if (field.mode == 'create' || field.mode == 'edit') {
          return {
            valid: false,
            message: __('A field is in edit mode. Save the field or cancel it before continuing.'),
          };
        }
      }

      return {
        valid: true,
        message: '',
      };
    },
    validateImagesSelected() {
      if (this.customBrandingLogoImage && this.survey.surveyImageLogoId == null) {
        return {
          valid: false,
          message: __(
            'You need to select a logo image for the survey or disable custom logo branding before proceeding.',
          ),
        };
      }

      if (this.customBrandingMainImage && this.survey.surveyImageMainId == null) {
        return {
          valid: false,
          message: __(
            'You need to select a main image for the survey or disable custom image branding before proceeding.',
          ),
        };
      }
      return {
        valid: true,
        message: '',
      };
    },
    removeAnswerOption(field, index) {
      if (field.answerOptions <= 1) return;
      
      field.answerOptions.splice(index, 1);
      this.updateAnswerOrder(field);
    },
    getErrors(field, attribute) {
      let errors = field.errors
        ? field.errors.filter((err) => {
            return err.attribute == attribute;
          })
        : [];

      return errors;
    },
    toggleSurveyTitleEditable(kind) {
      if (kind === false && this.survey.title.length < 3) {
        swal('Whoops!', 'The survey title should be at least 3 characters.', 'error');
        return;
      }
      this.titleEditable = kind;
    },
    previewField(fieldType) {
      let order = this.survey.fields.length;

      if (!this.currentPreviewField) {
        this.addNewField(fieldType, order, 'temporary_preview');
      }
    },
    removePreviewField() {
      let ind = false;

      if (this.currentPreviewField) {
        for (let index in this.survey.fields) {
          if (this.survey.fields[index].mode == 'temporary_preview') {
            ind = index;
            break;
          }
        }
      }

      if (ind) {
        this.survey.fields.splice(ind, 1);
      }
    },
    editPreviewField() {
      if (!this.currentPreviewField) return;
      this.currentPreviewField.mode = 'create';
    },
    toggleOptions(index) {
      // Untoggle active options on second click
      if (index == this.activeOptions) {
        this.activeOptions = null;
        return;
      }

      this.activeOptions = index;
    },
    cancelAll() {
      if (this.surveyModified) {
        swal(
          {
            title: `Exit Survey?`,
            text: "The changes won't be saved.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#017db9',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Exit without saving',
          },
          async (result) => {
            if (result) {
              window.location.href = '/surveys';
            }
          },
        );
      } else {
        window.location.href = '/surveys';
      }
    },
    cancelQuestion(index) {
    this.survey.fields.splice(index, 1);
  },
    cancelChanges(index) {
      this.survey.fields[index].mode = 'preview';
    },
    hasPlaceholder(fieldType) {
      if (fieldType == 'text' || fieldType == 'string') {
        return true;
      }

      return false;
    },
    // Shows if a field has customizable answers
    hasAnswers(fieldType) {
      if (fieldType == 'radiobutton' || fieldType == 'checkbox') {
        return true;
      }

      return false;
    },
    validateQuestionBeforeSave(index) {
      let field = this.survey.fields[index];

      field.errors = [];

      if (!field.title || field.title == '') {
        field.errors.push({
          attribute: 'title',
          message: 'A title is required',
        });
      }

      for (let option of field.answerOptions) {
        if (option.value == '' || !option.value) {
          field.errors.push({
            attribute: 'answer_options',
            message: 'Not all options have a value',
          });
          break;
        }
      }

      if (field.errors.length == 0) {
        return true;
      }

      return false;
    },
  saveQuestion(index) {
    this.selectedTriggerField = null;
    this.selectedTriggerAnswerOption = null;

    // removes edit mode
    if (!this.validateQuestionBeforeSave(index)) {
      return;
    }

    if (this.survey.fields[index].topicId == 0) {
      this.survey.fields[index].topicId = null;
    }

    this.survey.fields[index].mode = 'preview';
    },
    fieldImage(fieldName) {
      return '/assets/img/1.0/' + fieldName + '.png';
    },
    toggleFieldMode(index, mode) {
      this.survey.fields[index].mode = mode;
      this.activeOptions = null;
    },
    addNew(event) {
      if (this.isInEditMode) {
        alert('Please save or cancel the field you are working on.');
        return;
      }

      this.selectedTriggerField = null;
      this.selectedTriggerAnswerOption = null;

      if (event.added) {
        this.addNewField(event.added.element, event.added.newIndex);
      } else if (event.moved) {
        const element = Object.assign({}, this.survey.fields[event.moved.oldIndex]);
        this.survey.fields.splice(event.moved.oldIndex, 1);
        this.survey.fields.splice(event.moved.newIndex, 0, element);

        this.survey.fields = this.survey.fields.map((field, idx) => {
          field.order = idx;
          return field;
        });
      }
    },
    dragStart(event) {
      try {
        event.items[0].classList.add('is-dragged');
      } catch (e) {}

      this.dragging = true;
    },
    dragEnd(event) {
      try {
        event.items[0].classList.remove('is-dragged');
      } catch (e) {
        //
      }

      this.dragging = false;
    },
    normalizer(node) {
      return {
        id: node.internalId,
        label: node.name,
        children: node.subtopics,
      };
    },
    async getTopics() {
      const topics = await SurveysService.topics.index();
      this.topics = topics.data;
      this.topics.unshift({
        id: 0,
        name: 'Select a topic',
      });
    },
    setVisibility(type) {
      const tabs = Object.keys(this.visible);
      if (this.visible[type] === true) {
        return (this.visible[type] = false);
      }
      tabs.forEach((key) => {
        this.visible[key] = false;
      });
      this.visible[type] = true;
      const elmnt = document.getElementById('survey-builder');
      elmnt.scrollIntoView();
    },
    validateSurvey() {
      if (!this.survey.title || this.survey.title.length < 3) {
        return {
          valid: false,
          message: 'The survey title is too short.',
        };
      }
      if (!this.survey.fields || this.survey.fields.length === 0) {
        swal('No fields', 'The survey has no fields.', 'error');
        return {
          valid: false,
          message: 'The survey has no fields.',
        };
      }

      return {
        valid: true,
        message: '',
      };
    },
    saveSurvey() {
    this.isSaving = true;
    // Validate survey submission
    let validation = this.validateSurvey();
    if (!validation.valid) {
        return swal('Whoops!', validation.message, 'error');
    }

    const survey = Object.assign({}, this.survey);
    for (let color in this.colorValues) {
        survey.options[color] = this.colorValues[color];
    }
    survey.fields = survey.fields.map((field, idx) => {
        field.order = idx;
        if (field.answerOptions && Array.isArray(field.answerOptions)) {
            field.answerOptions = field.answerOptions.map((option, optionIdx) => {
                option.order = optionIdx;
                return option;
            });
            // Sorting asnweroptions by order
            field.answerOptions.sort((a, b) => a.order - b.order);
        }
        return field;
    });

    survey.rules = Object.values(survey.rules).filter(rule => rule);

    // Normalize rule time format
    survey.rules = survey.rules.map((rule) => {
        if (rule.time && !rule.time.toString().endsWith(':00')) {
            rule.time = rule.time.toString().padStart(2, 0) + ':00:00';
        }
        return rule;
    });

    survey.surveyImageMainId = this.customBrandingMainImage ? survey.surveyImageMainId : null;
    survey.surveyImageLogoId = this.customBrandingLogoImage ? survey.surveyImageLogoId : null;
    survey.infoFields = this.infoFields || {};

    SurveysService.save(survey).then(() => {
        window.location.href = '/surveys/#surveys';
    });

    this.isSaving = false;
},
      addFieldAnswer(field) {
      field.answerOptions.push({
      value: '',
      alertEnabled: false,
      order: field.answerOptions.length,
      uuid: uuidv4(),
    });
    },
    removeFieldAnswer(field, answerIndex) {
      if (field.answerOptions.length > 1) {
        field.answerOptions.splice(answerIndex, 1);
      }
    },
    removeField(index, safe = false) {
      const answerOptionUuids = this.survey.fields[index].answerOptions
        ? this.survey.fields[index].answerOptions.map((answerOption) => answerOption.uuid)
        : [];
      // When a field is removed we don't want the contextual menu
      // to stay active for the element that will likely replace it
      this.activeOptions = null;

      const fieldToRemove = this.survey.fields[index];
      // Clear triggers from any fields dependent on this field
      this.clearFieldTriggers(fieldToRemove, answerOptionUuids);

      this.survey.fields.splice(index, 1);

      // Fix ordering
      for (let field of this.survey.fields) {
        if (field.order > index) field.order -= 1;
      }
    },

    clearFieldTriggers(deletedField, answerOptionUuids) {
      const isRangeField = deletedField.type === 'range';
      const firstAnswerOption = answerOptionUuids[0];
      const answerOptionSet = isRangeField ? null : new Set(answerOptionUuids);

      this.survey.fields.forEach(field => {
        if (field.triggeredBy) {
          const isTriggeredByAnswerOptions = field.triggeredBy.some(trigger =>
            isRangeField ? trigger === firstAnswerOption : answerOptionSet.has(trigger)
          );

          if (isTriggeredByAnswerOptions) {
            // Clear the triggeredBy array and other related properties
            field.triggeredBy = [];
            field.triggers = [];
            field.hasTriggerEnabled = false;

            // Add notification about the unlinking if needed
            field.notification = `The trigger field (Title: ${deletedField.title}) has been removed. Please adjust this question if necessary.`;
          }
        }
      });
    },
  getDefaultAnswerOptions(fieldType) {
      let options = [];

      if (fieldType === 'range') {
        options = Array(10)
          .fill(0)
          .map((value, idx) => {
            return {
              value: idx + 1,
              alertEnabled: idx < 6,
              uuid: uuidv4(),
            };
          });
      }

      if (fieldType === 'checkbox' || fieldType === 'radiobutton') {
        options = [
          { 
            value: 'Option #1',
            alertEnabled: false,
            uuid: uuidv4(),
          },
          {
            value: 'Option #2',
            alertEnabled: false,
            uuid: uuidv4(),
          },
        ];
      }
      if (fieldType === 'yes_no') {
        options = [
          {
            value: 'Yes, sure!',
            alertEnabled: false,
            uuid: uuidv4(),
          },
          {
            value: 'Not really.',
            alertEnabled: false,
            uuid: uuidv4(),
          },
        ];
      }

      return options;
    },
    addNewField(fieldType, order, mode = 'create') {
      let numOfFields = 0;

      // let loop = true
      // while (loop) {
      //     if (this.survey.fields[order] && this.survey.fields[order].triggeredBy.length) {
    
      //         order++
      //     } else {
      //         loop = false
      //     }
      // }

      for (const field of this.survey.fields) {
        if (field.type == fieldType) numOfFields++;
      }

      const field = {
        type: fieldType,
        description: '',
        title: '',
        required: fieldType != 'explanation' ? true : false,
        mode: mode,
        field_id: fieldType + (numOfFields + 1).toString(),
        group: null,
        isNps: false,
        internalId: this.internalId,
        placeholder: '',
        order,
        errors: [],
        triggeredBy: [],
        hasTriggerEnabled: false,
        topicId: 0,
        condensed: false,
        alternativeStyle: false,
      };

      if (mode == 'temporary_preview') {
        field.title = 'Please rate your experience';
        field.description = 'Your opinion is valuable. Please share more details about your experience.';
      }
      this.internalId++;
      field.answerOptions = this.getDefaultAnswerOptions(fieldType),
      this.survey.fields.splice(order, 0, field);
      this.survey.fields.forEach((field, idx) => {
        field.order = idx;
      });

      Vue.nextTick(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    },
    checkSingleNps(e) {
      let npsCount = this.survey.fields.reduce((n, f) => (f.isNps ? n + 1 : n), 0);

      if (e.target.checked && npsCount >= 1) {
        swal('NPS Question limit', 'Only one (1) question can be selected as NPS.', 'info');
        e.target.checked = false;
      }
    },
  },
};
</script>

<style>
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
.sweet-alert .sa-input-error.show {
  opacity: 0;
  transform: scale(0);
}
.survey-rules-container {
  background: white;
  max-width: 600px;
  margin: auto;
  display: flex;
  padding: 15px 30px;
  border: 10px #f2f2f2 solid;
  border-radius: 500px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.survey-rules-container .line {
  display: flex;
  flex-direction: row;
}

.survey-rules-container .line .item {
  padding: 0 10px;
}

.required-checkbox {
  margin-left: 10px;
  min-height: 20px;
}

.required-checkbox input {
  margin-top: 0;
}

.multiselect__tag {
  background: #00aef1;
}

.multiselect__tag-icon:after {
  content: '\D7';
  color: #ffffff;
  font-size: 14px;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #00aef1;
}

.multiselect__option--highlight {
  background: #00aef1;
  outline: none;
  color: #fff;
}

.multiselect__option--highlight:after {
  content: attr(data-select);
  background: #0ba3df;
  color: #fff;
}
.mobile-draggable-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 5px;
  z-index: 1000;
}

.mobile-draggable-icons {
  display: flex;
  gap: 15px;
  overflow-x: auto;
  padding: 5px;
}

.mobile-circle-icon {
  width: 60px;
  height: 60px;
  background-color: #ffffff; 
  border: 1px solid #0ba3df;; 
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: grab;
  transition: all 0.3s ease-in-out;
}

.mobile-circle-icon:hover {
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3); 
  transform: translateY(-3px); 
}

.mobile-circle-icon img {
  width: 20px;
  height: 20px;
}

.field-label {
  font-size: 11px; 
  font-weight: 500;
  color: #333;
  margin-top: 5px;
  text-align: center;
}

</style>
